import React, { useCallback, useEffect, useState } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import TabsButton from 'src/Components/AllTabs/TabsButton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import 'src/assets/css/Carousel/TabsSlider.css'
import { TabType } from 'src/types/GlobalInterfaces'
import clsx from 'clsx'

interface IProps {
    tabs: TabType[],
    className?: string,
    onChange?: (tab: TabType) => void,
    activeTab?: TabType,
    showCount?: boolean,
    buttonProps?: React.HTMLAttributes<HTMLButtonElement>
}

const TabsSlideContainer = ({tabs, className , onChange , activeTab, buttonProps, showCount = false}: IProps) => {
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);

  const [emblaRef, emblaApi] = useEmblaCarousel({
    dragFree: true,
    containScroll: 'keepSnaps',
    align: 'center',
    skipSnaps: false
  })

  // Update scroll buttons state
  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setCanScrollPrev(emblaApi.canScrollPrev());
    setCanScrollNext(emblaApi.canScrollNext());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);
    return () => {
      emblaApi.off("select", onSelect);
      emblaApi.off("reInit", onSelect);
    };
  }, [emblaApi, onSelect]);

  // Navigation functions
  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  // Scroll to active tab when it changes
  const scrollToActiveTab = useCallback(() => {
    if (!emblaApi || !activeTab) return
    
    const activeIndex = tabs.findIndex(tab => tab.name === activeTab.name)
    if (activeIndex !== -1) {
      emblaApi.scrollTo(activeIndex)
    }
  }, [emblaApi, activeTab, tabs])

  // Scroll to active tab on mount and when activeTab changes
  useEffect(() => {
    scrollToActiveTab()
  }, [scrollToActiveTab])

  const handleTabClick = useCallback((tab: TabType, index: number) => {
    // First trigger the onChange
    onChange?.(tab)
    
    // Then scroll to the clicked tab
    // if (emblaApi) {
    //   emblaApi.scrollTo(index, false)
    // }
  }, [emblaApi, onChange])

  return (
    <div className={clsx("w-full h-fit relative tab-slider-container-main", className)}>
      {/* Navigation Buttons - Only show when scrolling is possible */}
      {/* {canScrollPrev && (
        <button
          className="absolute left-0 top-1/2 -translate-y-1/2 z-10 px-0.5 bg-gradient-to-r from-[#F6FAFF] to-transparent h-full flex items-center justify-center text-gray-600 hover:text-gray-800 transition-all duration-200"
          onClick={scrollPrev}
        >
          <FontAwesomeIcon icon={faChevronLeft} size="xs" />
        </button>
      )}

      {canScrollNext && (
        <button
          className="absolute right-0 top-1/2 -translate-y-1/2 z-10 px-0.5 bg-gradient-to-l from-[#F6FAFF] to-transparent h-full flex items-center justify-center text-gray-600 hover:text-gray-800 transition-all duration-200"
          onClick={scrollNext}
        >
          <FontAwesomeIcon icon={faChevronRight} size="xs" />
        </button>
      )} */}

      <div className="tabs-slider-embla" >
        <div className="tabs-slider-embla__viewport" ref={emblaRef}>
          <div className="tabs-slider-embla__container">
            {tabs.map((tab, index) => (
              <div key={index} className="tabs-slider-embla__slide">
                <TabsButton 
                  name={tab.name} 
                  active={activeTab?.name === tab.name} 
                  setActiveTab={() => handleTabClick(tab, index)} 
                  count={tab.count}
                  showCount={showCount}
                  {...buttonProps}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TabsSlideContainer